import { createFileRoute } from '@tanstack/react-router'
import { EmptyState } from '@/shared/ui/empty-state'

export const Route = createFileRoute('/calls/')({
  component: () => (
    <EmptyState
      icon="phone-call"
      title="Выбери звонок"
      description="Слева — завершённые звонки; в звонке видно транскрипт и телеметрию ходов"
    />
  ),
})
